<script>
    import Header from '../components/Header.svelte';
    import Footer from '../components/Footer.svelte';
</script>

<Header />

<!-- welcome section -->
<!--breadcumb start here-->
<section class="xs-banner-inner-section parallax-window" style="background-image:url('assets/images/about_bg.png')">
	<div class="xs-black-overlay"></div>
	<div class="container">
		<div class="color-white xs-inner-banner-content">
			<h2>About Us</h2>
			<p>Give a helping hand for poor people</p>
			<ul class="xs-breadcumb">
				<li class="badge badge-pill badge-primary"><a href="index.html" class="color-white"> Home /</a> About</li>
			</ul>
		</div>
	</div>
</section>
<!--breadcumb end here--><!-- End welcome section -->


<main class="xs-main">
	<!-- video popup section section -->
	<div class="xs-video-popup-section">
	<div class="container">
		<div class="row">
			<div class="col-lg-8 content-center">
				<div class="xs-video-popup-wraper">
					<img src="assets/images/video_img.jpg" alt="">
					<div class="xs-video-popup-content">
						<a href="https://www.youtube.com/watch?v=Tb1HsAGy-ls" class="xs-video-popup xs-round-btn">
							<i class="fa fa-play"></i>
						</a>
					</div><!-- .xs-video-popup-content end -->
				</div><!-- .xs-video-popup-wraper end -->
			</div>
		</div><!-- .row end -->
	</div><!-- .container end -->
</div>	<!-- End video popup section section -->

	<!-- video popup section section -->
	<section class="xs-content-section-padding">
	<div class="container">
		<div class="row">
			<div class="col-lg-11 content-center">
				<div class="xs-heading xs-mb-100 text-center">
					<h2 class="xs-mb-0 xs-title">We are an Globian non-profit organization that <span class="color-green">supports</span> good causes and positive change all over the world.</h2>
				</div>
			</div>
		</div><!-- .row end -->
		<div class="row">
			<div class="col-md-4">
				<div class="xs-about-feature">
					<h3>Our Mission</h3>
					<p class="lead">The CharityPress community was named a “Top 25 Best Global Philanthropist” by Barron’s. We beat Oprah. And, Mashable named CharityPress something like that.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="xs-about-feature">
					<h3>Our Vission</h3>
					<p class="lead">The Globian Fund for Charities seeks positive change around the world through support of non-profit organizations dedicated to social, cultural.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="xs-about-feature">
					<h3>Our Values</h3>
					<ul class="xs-unorder-list play green-icon">
						<li>Accountability</li>
						<li>Reliability</li>
						<li>Cost-effectiveness</li>
						<li>Personal service</li>
					</ul>
				</div>
			</div>
		</div><!-- .row end -->
	</div><!-- .container end -->
</section>	<!-- End video popup section section -->

	<!-- funfacts section -->
	<div class="xs-funfact-section xs-content-section-padding waypoint-tigger parallax-window" style="background-image: url('assets/images/backgrounds/parallax_1.jpg')">
	<div class="container">
		<div class="row col-lg-10 xs-heading mx-auto">
			<h2 class="xs-title color-white small">Our agency has been present for over 30 years. We make the best for all our children.</h2>
		</div>
		<div class="row">
			<div class="col-lg-3 col-md-6">
				<div class="xs-single-funFact color-white">
					<i class="icon-donation_2"></i>
					<span class="number-percentage-count number-percentage" data-value="10" data-animation-duration="3500">0</span><span>M</span>
					<small>Causes</small>
				</div>
			</div>
			<div class="col-lg-3 col-md-6">
				<div class="xs-single-funFact color-white">
					<i class="icon-group"></i>
					<span class="number-percentage-count number-percentage" data-value="25" data-animation-duration="3500">0</span><span>k</span>
					<small>Valunteer</small>
				</div>
			</div>
			<div class="col-lg-3 col-md-6">
				<div class="xs-single-funFact color-white">
					<i class="icon-children"></i>
					<span class="number-percentage-count number-percentage" data-value="30" data-animation-duration="3500">0</span><span>k</span>
					<small>Childrens</small>
				</div>
			</div>
			<div class="col-lg-3 col-md-6">
				<div class="xs-single-funFact color-white">
					<i class="icon-planet-earth"></i>
					<span class="number-percentage-count number-percentage" data-value="14" data-animation-duration="3500">0</span><span>k</span>
					<small>Countrys</small>
				</div>
			</div>
		</div><!-- .row end -->
	</div><!-- .container end -->
	<div class="xs-black-overlay"></div>
</div>	<!-- End funfacts section -->

	<!-- what we do section -->
	<section class="xs-section-padding">
	<div class="container">
		<div class="xs-heading row xs-mb-60">
			<div class="col-md-9 col-xl-9">
				<h2 class="xs-title">What We Do</h2>
				<span class="xs-separetor dashed"></span>
				<p>It allows you to gather monthly subscriptions from fans to help fund your creative projects. They also encourage their users to offer rewards to fans as a way to repay them for their support.</p>
			</div><!-- .xs-heading-title END -->
		</div><!-- .row end -->
		<div class="row">
			<div class="col-md-6 col-lg-3">
				<div class="xs-service-promo">
					<span class="icon-water color-orange"></span>
					<h5>Pure Water <br>For Poor People</h5>
					<p>663 million people drink dirty water. Learn how access to clean water can improve health, boost local economies.</p>
				</div><!-- .xs-service-promo END -->
			</div>
			<div class="col-md-6 col-lg-3">
				<div class="xs-service-promo">
					<span class="icon-groceries color-red"></span>
					<h5>Healty Food <br>For Poor People</h5>
					<p>663 million people drink dirty water. Learn how access to clean water can improve health, boost local economies.</p>
				</div><!-- .xs-service-promo END -->
			</div>
			<div class="col-md-6 col-lg-3">
				<div class="xs-service-promo">
					<span class="icon-heartbeat color-purple"></span>
					<h5>Medical <br>Facilities for People</h5>
					<p>663 million people drink dirty water. Learn how access to clean water can improve health, boost local economies.</p>
				</div><!-- .xs-service-promo END -->
			</div>
			<div class="col-md-6 col-lg-3">
				<div class="xs-service-promo">
					<span class="icon-open-book color-green"></span>
					<h5>Pure Education <br>For Every Children</h5>
					<p>663 million people drink dirty water. Learn how access to clean water can improve health, boost local economies.</p>
				</div><!-- .xs-service-promo END -->
			</div>
		</div><!-- .row end -->
	</div><!-- .container end -->
</section>	<!-- End what we do section -->
</main>

<Footer />